import TinderCard from 'react-tinder-card';
import {useEffect, useState} from "react";
// import ChatContainer from "../components/ChatContainer";
import axios from 'axios';
import {useCookies} from 'react-cookie';
import {Link} from "react-router-dom";
import {saveMatchedUser} from "../action/matchedUserAction";
import {useDispatch} from "react-redux";


const Dashboard = () => {
    const [user, setUser] = useState(null)
    const [genderedUsers, setGenderedUsers] = useState(null)
    const [cookies, setCookie, removeCookie] = useCookies(['user'])
    const userId = cookies.UserId
    const [lastDirection, setLastDirection] = useState()
    const dispatch = useDispatch()
    const getUser = async () => {
        try {
            const response = await axios.get('https://match-app-backend.herokuapp.com/user', {
                params: {userId}
            })

            setUser(response.data)
            saveMatchedUser(response.data)(dispatch)
        } catch (err) {
            console.log(err)
        }
    }

    const getGenderedUser = async () => {
        try {
            const response = await axios.get('https://match-app-backend.herokuapp.com/gendered-users', {
                params: {gender: user?.gender_interest}
            })
            setGenderedUsers(response.data)

        } catch (err) {
            console.log(err)
        }
    }


    const matchedUserIds = user?.matches.map(({user_id}) => user_id).concat(userId)
    const filteredGenderedUsers = genderedUsers?.filter(
        genderedUsers => !matchedUserIds.includes(genderedUsers.user_id)
    )
    const updatedMatches = async (matchedUserId) => {
        try {
            await axios.put('https://match-app-backend.herokuapp.com/addmatch', {
                    userId,
                    matchedUserId
                }
            )
            getUser()
        } catch (err) {
            console.log(err)
        }
    }


    const swiped = (direction, swipedUserId) => {
        if (direction === 'right') {
            updatedMatches(swipedUserId)
        }
        // console.log('removing: ' + swipedUserId)
        setLastDirection(direction)
    }

    // const outOfFrame = (name) => {
    //     console.log(name + ' left the screen!')
    // }

    useEffect(() => {
        getUser()
    }, [])

    useEffect(() => {
        if (user) {
            getGenderedUser()
        }
    }, [user])

    return (
        <>
            {user &&
            <div className={'dashboard'}>
                {/*<ChatContainer user={user}/>*/}
                <div className="button-container">
                    <Link to={'/matchpage'}>
                        <button className={'primary-button'}>Take me to my matches!</button>
                    </Link>
                </div>
                <div className="swiper-container">
                    <div className="card-container">

                        {filteredGenderedUsers?.map((genderedUser) =>
                            <TinderCard className='swipe' key={genderedUser.user_id}
                                        onSwipe={(dir) => swiped(dir, genderedUser.user_id)}
                            >
                                <div style={{backgroundImage: 'url(' + genderedUser.url + ')'}} className='card'>
                                    <h3>{genderedUser.first_name}</h3>
                                </div>
                            </TinderCard>
                        )}
                        {/*<div className="swipe-info">*/}
                        {/*    {lastDirection ? <p>You swiped {lastDirection}</p> : <p></p>}*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
            }
        </>
    )
}

export default Dashboard